import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
	Box,
	Button,
	CardActionArea,
	CardActions,
	Card,
	CardContent,
	CardMedia,
	Typography,
} from '@mui/material';
import { Casino, Delete, Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { deleteAdventure } from './../../services/adventuresRequest'

export default function GameCard({ adventure, refreshAdventures }) {
	const { t, i18n } = useTranslation();

	const defaultCover =
		'//upload.wikimedia.org/wikipedia/commons/thumb/b/be/Role_playing_gamers.jpg/800px-Role_playing_gamers.jpg';

	const redirectToGame = () => {
		window.location.href = `/game/${adventure.ID}`;
	};

	const onDelete = async (event) => {
		event.stopPropagation();		
		await deleteAdventure(adventure.ID);
		refreshAdventures();
	}

	return (
		<Card sx={{ maxWidth: 345, position: 'relative' }}>
			<CardActionArea onClick={redirectToGame}>
				<CardMedia
					component="img"
					height="140"
					image={adventure.cover || defaultCover}
					alt={adventure.name}
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="div">
						{adventure.name}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions>
				<Button
					size="small"
					color="primary"
					startIcon={<Casino />}
					onClick={redirectToGame}>
					{t('management.game.card.play')}
				</Button>
				{adventure.isOwner && (
					<Box sx={{ marginLeft: 'auto' }}>
						<Button
							startIcon={<Edit />}
							component={RouterLink}
							to={`/adventure/${adventure.ID}`}
							size="small"
							color="primary">
							{t('management.game.card.edit')}
						</Button>
					</Box>
				)}
			</CardActions>
			<Box sx={{ position: 'absolute', top: 8, right: 5, zIndex: 100 }}>
				<Button
					size="small"
					color="error"
					onClick={onDelete}
					startIcon={<Delete />}
					sx={{
						backgroundColor: 'rgba(255, 255, 255, 0.8)',
						borderRadius: '50%',
						minWidth: 'auto',
						padding: '4px 0px 4px 10px',
					}}>				
				</Button>
			</Box>
		</Card>
	);
}
